// extracted by mini-css-extract-plugin
export var container = "_94-0";
export var error = "_94-9";
export var label = "_94-5";
export var light = "_94-6";
export var md = "_94-3";
export var sm = "_94-2";
export var thin = "_94-8";
export var thinBold = "_94-7";
export var vertical = "_94-4";
export var xs = "_94-1";